import { ACTION_LABELS, type Action, type Bindings, keyLabel } from "../input/Input";

interface Group { title: string; actions: Action[]; }

const GROUPS: Group[] = [
  { title: "Fly",     actions: ["pitchUp", "pitchDown", "yawLeft", "yawRight", "rollLeft", "rollRight"] },
  { title: "Engine",  actions: ["throttleUp", "throttleDown"] },
  { title: "Combat",  actions: ["fire", "skill1", "skill2", "skill3", "boostToRing"] },
  { title: "System",  actions: ["openChat", "toggleKeymap", "openSettings", "respawn"] },
];

export class KeyOverlay {
  private el = document.getElementById("keymap")!;
  private body = document.getElementById("keymapTable")!;

  toggle(b: Bindings) {
    if (this.el.classList.contains("hidden")) this.show(b);
    else this.hide();
  }
  show(b: Bindings) {
    this.render(b);
    this.el.classList.remove("hidden");
  }
  hide() { this.el.classList.add("hidden"); }

  private render(b: Bindings) {
    let html = "";
    for (const g of GROUPS) {
      html += `<tr class="grp"><td colspan="2">${g.title}</td></tr>`;
      for (const a of g.actions) {
        const keys = (b[a] || []).map(k => `<kbd>${keyLabel(k)}</kbd>`).join(" ");
        html += `<tr><td class="action">${ACTION_LABELS[a]}</td><td class="keys">${keys || '<span class="dim">unbound</span>'}</td></tr>`;
      }
    }
    this.body.innerHTML = html;
  }
}
